import { MouseEventHandler, ReactNode } from 'react'
import {
  Text,
  Button,
  Link,
  IconArrowRight,
  GreyGrey10,
  GreyGrey40,
  GreyGrey60,
  GreyGrey80,
  Primary14SemiBold,
  Primary14ExtendedRegular,
  Flex
} from '@sequencehq/core-components'

export const WorkspaceList = ({ children }: { children?: ReactNode }) => {
  return (
    <Flex
      boxShadow="0px 1px 3px 0px rgba(0, 0, 0, 0.08)"
      direction="column"
      borderWidth={1}
      borderColor={GreyGrey40}
      borderRadius="8px"
      overflow="hidden"
      maxHeight="420px"
    >
      <Flex
        direction="column"
        overflowY="auto"
        maxHeight="420px"
        css={{
          '& > *:not(:last-child)': {
            borderBottom: '1px solid',
            borderColor: GreyGrey40
          }
        }}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export const WorkspaceListItem = ({
  name,
  action,
  link,
  ...props
}: {
  name: string
  action?: ReactNode
  link: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  'data-testid'?: string
}) => {
  return (
    <Link
      to={link}
      _hover={{
        textDecoration: 'none',
        background: GreyGrey10
      }}
      display="flex"
      padding="0 16px"
      height="48px"
      minHeight="48px"
      alignItems="center"
      {...props}
    >
      <Flex alignItems="center" gap="16px" flex={1}>
        <Text {...Primary14SemiBold} fontWeight="600" color={GreyGrey80}>
          {name}
        </Text>
      </Flex>
      <Flex alignItems="center" gap="8px" {...Primary14ExtendedRegular}>
        {action}
        <Button
          size="16px"
          variant="unstyled"
          aria-label="Action"
          icon={<IconArrowRight color={GreyGrey60} />}
        />
      </Flex>
    </Link>
  )
}

WorkspaceList.Item = WorkspaceListItem
